// App Imports
import {
  MEDIA_GALLERY_LIST_REQUEST,
  MEDIA_GALLERY_LIST_RESPONSE,
  MEDIA_GALLERY_LIST_DONE,
  MEDIA_GALLERY_LIST_RESET
} from '../actions/types'

// Initial State
const mediaGalleryInitialState = {
  isLoading: false,
  list: []
}

// Reducer
const list = (state = mediaGalleryInitialState, action) => {
  switch (action.type) {
    case MEDIA_GALLERY_LIST_REQUEST:
      return {
        ...state,
        isLoading: action.isLoading
      }

    case MEDIA_GALLERY_LIST_RESPONSE:
      return {
        ...state,
        list: action.list
      }

    case MEDIA_GALLERY_LIST_DONE:
      return {
        ...state,
        isLoading: false
      }

    case MEDIA_GALLERY_LIST_RESET:
      return { ...mediaGalleryInitialState }

    default:
      return state
  }
}

export default list
